import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PoLookupFilter, PoLookupFilteredItemsParams } from '@po-ui/ng-components';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IBranchAPI } from '../../interfaces/branch.model';

@Injectable({
  providedIn: 'root'
})

export class BranchService implements PoLookupFilter {
  public branch: string;
  protected url: string;

  constructor(
    private http: HttpClient
  ) {
    this.url = `${environment.url}api/framework/environment/v1/branches`;
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<IBranchAPI> {
    const params = {
      description: filteredParams.filter,
      page: filteredParams.page,
      pageSize: filteredParams.pageSize
    };
    return this.http.get<IBranchAPI>(`${this.url}?EnterpriseGroup=${filteredParams.filterParams}`, { params });
  }

  getObjectByValue(value: string): Observable<IBranchAPI> {
    return this.http.get<IBranchAPI>(`${this.url}/${value}`);
  }

  getBranchFromStorage(): string {
    return localStorage.getItem('branch');
  }

  setBranchToStorage(branch: string): void {
    localStorage.setItem('branch', branch);
  }

  cleanStorageBranch(): void {
    localStorage.removeItem('branch');
  }
}
